"use strict";

if (typeof window === "undefined") {
  require("dotenv").config();
}

// Staging DB Config
const dbConfig = {
  username: process.env.DB_USERNAME,
  password: process.env.DB_PASSWORD,
  host: process.env.DB_HOST,
  port: process.env.DB_PORT,
  dialect: "mysql",
  // keeping the logging option to false, it makes the development process bit annoying and avoid unnecessary logs
  logging: false
};
module.exports = {
  environment: "staging",
  protocol: "https://",
  api_url: "https://api.totaly.uk/api",
  client_host: "totaly.uk",
  distributor_host: "https://app.totaly.uk/",
  websocket_url: "wss://api.totaly.uk",
  port: 9010,
  s3: {
    bucket: process.env.S3_BUCKET,
    access: {
      bucket: process.env.S3_BUCKET,
      endpoint: process.env.S3_ENDPOINT,
      region: process.env.S3_REGION,
      forcePathStyle: false,
      credentials: {
        secretAccessKey: process.env.S3_SECRET_ACCESS_KEY,
        accessKeyId: process.env.S3_ACCESS_KEY_ID
      }
    }
  },
  bodyLimit: "5mb",
  database: {
    database: process.env.DB_NAME,
    ...dbConfig,
    pool: {
      max: Number(process.env.DB_POOL_MAX) || 15
    },
    dialectOptions: {
      maxPreparedStatements: 3000
    }
  },
  // keep the tokens alive for 8hrs
  jwt_expiration: 60 * 60 * 8,
  customer_jwt_expiration: process.env.CUSTOMER_JWT_EXPIRATION || "96h",
  jwt_encryption: process.env.JWT_ENCRYPTION,
  admin_token_secret: process.env.ADMIN_TOKEN_SECRET,
  clover: {
    api_url: "https://sandbox.dev.clover.com"
  },
  mailgun: {
    api_key: process.env.MAILGUN_API_KEY,
    domain: process.env.MAILGUN_DOMAIN,
    sender_address: "cs@totalwinewholesale.com",
    reply_address: "txwholesale@totalwine.com"
  },
  twilio: {
    account_sid: process.env.TWILIO_ACCOUNT_SID,
    auth_token: process.env.TWILIO_AUTH_TOKEN,
    text_from: process.env.TWILIO_FROM_NUMBER
  },
  logs: {
    loggly: {
      token: process.env.LOGGLY_TOKEN,
      subdomain: "ynvoice",
      tags: ["totalwine-api", "totalwine-staging"],
      json: true
    }
  },
  otel: {
    endpoint: process.env.OTEL_EXPORTER_OTLP_ENDPOINT,
    authHeader: process.env.OTEL_EXPORTER_OTLP_AUTH,
    environment: "staging",
    metricsToken: process.env.METRICS_BEARER_TOKEN,
    // Git SHA of the deploy, set by the deploy workflow.
    serviceVersion: process.env.OTEL_SERVICE_VERSION,
    // Standard OTel SDK variables; "none" turns a signal off. Metrics are
    // scraped from /metrics, so OTLP metric push is opt-in ("otlp").
    tracesExporter: process.env.OTEL_TRACES_EXPORTER || "otlp",
    logsExporter: process.env.OTEL_LOGS_EXPORTER || "otlp",
    metricsExporter: process.env.OTEL_METRICS_EXPORTER || "none"
  },
  posthog: {
    api_key: process.env.POSTHOG_API_KEY
  },
  order_app_subdomain: "order"
};